module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpanded.9125a0a.woff2";